import { css, cva } from '@flipster/styled-system/css';

const rowPadding = 16;

const lineInsetPadding = 32;
const lineInsetScroll = 48;

export const selectedItemPadding = css({
  pos: 'relative',
  zIndex: 2,
  overflow: 'visible',
  _before: {
    content: '""',
    pos: 'absolute',
    left: -12,
    top: '50%',
    transform: 'translateY(-50%)',
    width: 12,
    height: 2,
    bgColor: 'background.default.level-1',
    zIndex: 2,
  },
  _after: {
    content: '""',
    pos: 'absolute',
    left: '100%',
    top: '50%',
    transform: 'translateY(-50%)',
    width: 12,
    height: 2,
    bgColor: 'background.default.level-1',
    zIndex: 2,
  },
});

export const selectedItemHover = cva({
  base: {
    _before: {
      py: 12,
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: 8,
      zIndex: -1,
      bgColor: 'background.default.level-1',
    },
    '&:hover::before': {
      bgColor: 'background.interaction.hover',
    },
  },
  variants: {
    isSelected: {
      true: {
        _before: {
          bgColor: 'background.default.level-0',
        },
        '&:hover::before': {
          bgColor: 'background.default.level-0',
        },
      },
    },
  },
});

export const timelineHorizontalContainer = cva({
  base: {
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      right: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      height: 2,
      backgroundColor: 'background.default.level-3',
      borderRadius: '1rem',
      zIndex: 0,
    },
  },
  variants: {
    lineInset: {
      [lineInsetPadding]: {
        '&::before': {
          left: lineInsetPadding,
          right: lineInsetPadding,
        },
      },
      [lineInsetScroll]: {
        '&::before': {
          left: lineInsetScroll,
          right: lineInsetScroll,
        },
      },
    },
  },
});

const scrollArrowButtonWidth = 48;

export const scrollArrowButton = cva({
  base: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    zIndex: 10,
    width: scrollArrowButtonWidth,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'content.default.level-5',
    visibility: 'visible',
    _hover: { color: 'inverse.white' },
    _disabled: { opacity: 0.4 },
  },
  variants: {
    side: {
      left: {
        left: 0,
        background: 'linear-gradient(90deg, #1C1C1C 0%, #1C1C1C 55%, transparent 80%)',
      },
      right: {
        right: 0,
        background: 'linear-gradient(270deg, #1C1C1C 0%, #1C1C1C 55%, transparent 80%)',
      },
    },
  },
});

export const timelineLeft = cva({
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  variants: {
    timeline: {
      true: {
        '&::before, &::after': {
          content: '""',
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 2,
          backgroundColor: 'background.default.level-3',
          borderRadius: '1rem',
        },
      },
    },
    position: {
      first: {
        '&::before': {
          display: 'none',
        },
        '&::after': {
          top: '50%',
          bottom: `-${rowPadding}px`,
        },
      },
      last: {
        '&::before': {
          top: `-${rowPadding}px`,
          bottom: '50%',
        },
        '&::after': {
          display: 'none',
        },
      },
      middle: {
        '&::before': {
          top: `-${rowPadding}px`,
          bottom: '50%',
        },
        '&::after': {
          top: '50%',
          bottom: `-${rowPadding}px`,
        },
      },
    },
  },
});

export const timelineDotWrapper = cva({
  base: {
    position: 'relative',
    zIndex: 2,
  },
});

export const timelineDot = cva({
  base: {
    w: 24,
    h: 24,
    m: 2,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 3,
    backgroundColor: 'background.default.level-4',
    color: 'content.default.level-2',
  },

  variants: {
    state: {
      current: { backgroundColor: 'background.accent.primary', color: 'content.default.level-5' },
    },
  },
});
